import { i18n } from '@lingui/core';
import { Button, Modal } from '@warp-ds/react';
import React from 'react';
import { useAppConfig } from '../../AppConfig';
import { useSearchParams } from '../../data/SearchParamsStore';
import { useLocationUrl } from '../../state/LocationUrl';
import { useScrollLockFix } from './ScrollLockFix';

const modalStyle: React.CSSProperties = {
    // @ts-expect-error Object literal may only specify known properties. ts(2322)
    '--w-modal-width': '300px',
};

type LoginModalProps = {
    isOpen: boolean;
    onDismiss: () => void;
    onLogin: () => void;
};

export function LoginModal(props: LoginModalProps) {
    const { isOpen, onDismiss, onLogin } = props;

    const { locationUrl } = useLocationUrl();
    const redirectUrl = new URL(locationUrl);

    const { searchParams } = useSearchParams();
    redirectUrl.search = searchParams.toString();

    const { isProbablyMobile, siteUrl } = useAppConfig();
    const loginUrl = new URL('/auth/login', siteUrl);
    loginUrl.searchParams.set(
        'redirectUrl',
        encodeURIComponent(redirectUrl.href),
    );

    useScrollLockFix();

    return (
        <Modal
            onDismiss={onDismiss}
            open={isOpen}
            style={!isProbablyMobile ? modalStyle : undefined}
            title={i18n.t({ id: 'saved-search.title', message: 'Save search' })}
        >
            <div className="flex flex-col space-y-16 py-4">
                <Button
                    fullWidth
                    onClick={onLogin}
                    href={loginUrl.href}
                    primary
                >
                    {i18n.t({
                        id: 'saved-search.login.login',
                        message: 'Log in',
                    })}
                </Button>

                <Button fullWidth onClick={onLogin} href={loginUrl.href}>
                    {i18n.t({
                        id: 'saved-search.login.create-account',
                        message: 'Create account',
                    })}
                </Button>
                <Button fullWidth onClick={onDismiss} quiet>
                    {i18n.t({
                        id: 'saved-search.login.cancel',
                        message: 'Cancel',
                    })}
                </Button>
            </div>
        </Modal>
    );
}
